import React from "react";
import { TextLink } from "nystem-components";

const TinymceLink = props => <TextLink {...props} />;
export default TinymceLink;
